import { ComponentParams } from '@sitecore-content-sdk/nextjs';
import { useMemo } from 'react';

const ignoredKeys = new Set([
  'GridParameters',
  'FieldNames',
  'DynamicPlaceholderId',
  'Styles',
  'styles',
]);
/**
 * Filter "magic list" of keys to ignore before passing those params to a child component as an array of key value pairs.
 * Does not re-render unless the params passed actually change using JSON.stringify
 *
 * @param params - Component parameters from parent props to be filtered.
 */
export const useSchedulingParamFilter = (params?: ComponentParams) => {
  // Create a stable key. Only run this hook when the params being passed change.
  const stringParams = JSON.stringify(params || {});
  return useMemo(() => {
    const pars = JSON.parse(stringParams) as ComponentParams;
    const array = Object.entries(pars || {}).map(([key, value]) => ({
      key,
      value,
    }));

    return array.filter((item) => !ignoredKeys.has(item.key));
  }, [stringParams]);
};
